import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      margin: '2rem 0.8rem',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      '& h1': {
        fontWeight: 600,
      },

      '& section': {
        height: '100%',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',

        '& h2': {
          fontWeight: 500,
          fontSize: '2.4rem',
        },

        '& svg': {
          color: palette.primary.dark,
          fontSize: '7.6rem',
        },
      },
    },

    inputsContainer: {
      marginTop: '4rem',

      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',

      '& .MuiTextField-root': {
        margin: 0,
        width: '100%',
      },
    },

    buttonsContainer: {
      marginTop: 'auto',

      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',

      '& > button, & > a': {
        margin: 0,
        width: 'fit-content',
      },
    },
  }),
)
